export type Event = {
  event_id: number
  user_number: number
  position: {
    x: number
    y: number
  }
  title: string
  description: string
  type: number
  type_name: string
  type_code: string
  event_types: EventType[]
  pet_friendly: boolean
  age_range: AgeRangeEnum
  action_url: string
  price: string
  address: string
  event_start_timestamp: Date
  event_end_timestamp: Date
  created_at: Date
  updated_at: Date
  location_title: string
  button_label: string
  event_images: EventImage[]
  favorited?: boolean
}

export type RawServerEvent = Event & {
  event_start_timestamp: string
  event_end_timestamp: string | null
  created_at: string
  updated_at: string
}

export type EventImage = {
  event_id: number
  event_image_id: number
  image_order: number
  image_url: string
  orientation: ImageOrientationEnum
}

export type EventType = {
  event_type_id: number
  human_name: string
  machine_name: string
  icon_link: string
}

// export type MarkerData = {
//   id: number
//   position: {
//     lat: number
//     lng: number
//   }
//   icon: string
//   label: string
//   info: string
//   location_title: string
//   event_start_timestamp: Date
//   event_end_timestamp: Date
//   event_images?: EventImage[]
// }
export type MarkerData = {
  position: google.maps.LatLngLiteral
  id?: number
  icon?: string
  label?: string
  info?: string
  event_images?: EventImage[]
  type?: string
  location_title?: string
  event_start_timestamp?: Date
  event_end_timestamp?: Date
  event_types?: EventType[]
  favorited?: boolean
  isPriority?: boolean
}

export enum AgeRangeEnum {
  ADULT = "ADULT",
  FAMILY = "FAMILY",
  TEEN = "TEEN",
  ANY = "ANY",
}

export enum ImageOrientationEnum {
  VERTICAL = "VERTICAL",
  HORIZONTAL = "HORIZONTAL",
}

export type AttractionType = {
  attraction_type_id: number
  human_name: string
  machine_name: string
  icon_link: string
}

export type AttractionImage = {
  attraction_id: number
  attraction_image_id: number
  image_order: number
  orientation: string
  image_url: string
}

export type Attraction = {
  attraction_id: number
  title: string
  description: string
  position: {
    x: number
    y: number
  }
  address: string
  location: string
  price: string
  action_url: string
  created_at: Date
  updated_at: Date
  attraction_types: AttractionType[]
  attraction_images: AttractionImage[]
}

export type AdvertisementType = {
  advertisement_id: number
  company_name: string
  action_link: string
  active: boolean
  advertisement_images_id: number
  large_image: string
  small_image: string
  mobile_image: string
  description: string
  slot_name: string
}
